import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-circle',
  templateUrl: './circle.component.html',
  styleUrls: ['./circle.component.scss'],
})
/**
 * Renders a circle with an icon inside
 */
export class CircleComponent implements AfterViewInit {
  @ViewChild('circle') circle!: any;

  iconStyle: string = '';
  @Input() size: string = '';
  _isLight = false;
  private _innerShadow = false;

  /**
   * Injects ChangeDetector so we can tell angular to detect
   * changes after view init
   * @constructor
   */
  constructor(private cd: ChangeDetectorRef) {}

  /**
   * Sets up responsiveness for icon on window resize
   */
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.iconStyle = this.getIconStyle();
  }

  /**
   * Sets up responsiveness for icon on content render change events
   */
  ngAfterViewInit(): void {
    this.iconStyle = this.getIconStyle();
    this.cd.detectChanges();
  }

  /**
   * Returns a scale that the icon inside circle should be transformed by
   * @return {number} a number that should be used in a
   * transform scale CSS function
   */
  getIconScale(): number {
    return (this.circle?.nativeElement.clientWidth / 24) * 0.725;
  }

  /**
   * Returns style that should apply to icon inside circle to make it responsive
   * @return {string} a CSS style dependent on an ideal icon scale
   */
  getIconStyle(): string {
    if (this.size === 'small') {
      return 'transform: scale(5.1)';
    }
    if (this.size === 'xsmall') {
      return 'transform: scale(1.0)';
    } else {
      return `transform: scale(${this.getIconScale()})`;
    }
  }

  /**
   * Decides if this icon has a lighter blue
   * @return {boolean}
   */
  @Input()
  get isLight(): boolean {
    return this._isLight;
  }

  /**
   * Sets this icon with a lighter blue simply by using an html attribute
   * @param {any} value
   */
  set isLight(value: any) {
    this._isLight = coerceBooleanProperty(value);
  }

  /**
   * Decides if this icon has inner shadow
   * @return {boolean}
   */
  @Input()
  get innerShadow(): boolean {
    return this._innerShadow;
  }

  /**
   * Places shadow inside instead of outside
   * @param {any} value
   */
  set innerShadow(value: any) {
    this._innerShadow = coerceBooleanProperty(value);
  }
}
